import React from "react";
import { G, FONT_FAMILY, OVERVIEW } from "../../constants/theme";

// The single heading pattern for every Overview section:
//
//   SMALL EYEBROW              (OVERVIEW.eyebrow)
//   Prominent section title    (OVERVIEW.title)
//   Readable description       (OVERVIEW.support)
//   ── gapHeaderBody ──
//   [content]
//
// `actions` renders a right-aligned control slot (sort selects, help popovers,
// status pills) on the same baseline as the eyebrow/title block.

export default function SectionHeader({
  eyebrow,
  title,
  description,
  light = false,
  actions = null,
  descriptionMaxWidth = 620,
  style = {},
}) {
  const titleColor = light ? "#FFFFFF" : G.gray900;
  const eyebrowColor = light ? "rgba(255,255,255,0.45)" : G.gray500;
  const descColor = light ? "rgba(255,255,255,0.55)" : G.gray600;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: OVERVIEW.gapSectionInner,
        marginBottom: OVERVIEW.gapHeaderBody,
        fontFamily: FONT_FAMILY,
        ...style,
      }}
    >
      <div style={{ minWidth: 0 }}>
        {eyebrow && (
          <div
            style={{
              ...OVERVIEW.eyebrow,
              color: eyebrowColor,
              marginBottom: OVERVIEW.gapEyebrowTitle,
            }}
          >
            {eyebrow}
          </div>
        )}
        {title && (
          <h2 style={{ ...OVERVIEW.title, color: titleColor, margin: 0 }}>{title}</h2>
        )}
        {description && (
          <p
            style={{
              ...OVERVIEW.support,
              color: descColor,
              margin: `${OVERVIEW.gapTitleDesc}px 0 0`,
              maxWidth: descriptionMaxWidth,
            }}
          >
            {description}
          </p>
        )}
      </div>
      {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}
